$(document).ready(function () {
    /**
     * Scroll to cart
     */
     if ($('#salesBanner').length) {
        let salesBannerHeight = Math.floor($('#salesBanner').outerHeight());
        
        if ($('#salesBanner').hasClass('isStick')) {
          $('.btn, #salesBanner, #promoBanner').on('click', function (event) {
            $('html, body').animate({
              scrollTop: $("#orderNow").offset().top - salesBannerHeight
            }, 1000);
          });
        } else {
          $('.btn, #salesBanner, #promoBanner').on('click', function (event) {
            $('html, body').animate({
              scrollTop: $("#orderNow").offset().top
            }, 1000);
          });
        }
      } else {
        $('.btn, #promoBanner').on('click', function (event) {    
          let bannerHeight = $('#promoBanner').outerHeight();
    
          if ($('body').hasClass('show-promoBanner')) {
            $('html, body').animate({
              scrollTop: $("#orderNow").offset().top - bannerHeight
            }, 1000);
          } else {
            $('html, body').animate({
              scrollTop: $("#orderNow").offset().top
            }, 1000);
          }
        });
      }

    /**
     * Shopping Cart
     */
    
    // Handle Subscribe Box
    $('#subscribeBox').on("click", function () {
        const checkbox = $('.cart__checkbox');
        const subscribeAttr = $(this).data('subscribe');

        // Activate Subscribe Prices
        if (checkbox.hasClass('checked')) {
            // Uncheck checkbox > Normal mode
            checkbox.removeClass('checked');

            // Set subscribe to false and change price-box title
            $(this).data('subscribe', false);
            $('#saveTitle').html('Instant Savings:');

            // Control UI if subscribe prices are not checked 
            if ($('body').hasClass('show-promoBanner')) {
                $('body').removeClass('show-promoBanner--club');
            }

        } else {
            // check checkbox > Subcribe mode
            checkbox.addClass('checked');

            // Set subscribe to true and change price-box title
            $(this).data('subscribe', true);
            $('#saveTitle').html('Member Savings:');

            // Control UI if subscribe prices are checked
            if ($('body').hasClass('show-promoBanner')) {
                $('body').addClass('show-promoBanner--club');
            }
        }

        $('.cart__product.active').trigger("click");
    });

    // Set Prices
    /**
     * Data Attributes list:
     * data-units="3"
     * data-amount="@@3-bottle-amount"
     * data-subscribe-amount="@@3-bottle-subscribe-amount"
     * data-sale-amount="@@3-bottle-sale-amount"
     * data-price="@@3-bottle-price"
     * data-save="@@3-bottle-save"
     * data-sale-save="@@3-bottle-sale-save"
     * data-subscribe-save="@@3-bottle-subscribe-save"
     * data-shipping="@@3-bottle-shipping"
     * data-subscribe-shipping="@@3-bottle-subscribe-shipping"
     * data-link="@@threeTracker"
     * data-subscribe-link="@@threeTracker-subscribe"
     */
    function setLinks() {
        let thisProduct = $(this);
        let link = '-link';
        let subscribe, sale;
        const subscribeAttr = $('#subscribeBox').data('subscribe');

        if (subscribeAttr === true) {
            subscribe = '-subscribe';
            
        } else {
            subscribe = '';
        }

        if ($('body').hasClass('show-promoBanner')) {
            sale = '-sale';
        } else {
            sale = '';
        }

        let param = $('.cta').attr('data-param');
        $('.cart .cta').attr('href', thisProduct.attr('data' + sale + subscribe + link) + param);
    };

    /**
     * Set Active Product 
     */
    function activeProduct() {
        let thisProduct = $(this);
        const subscribeAttr = $('#subscribeBox').data('subscribe');
        const price = thisProduct.attr('data-price');

        let amount, save, shipping, sale, subscribe;

        if (subscribeAttr === true) {
            subscribe = '-subscribe';
            amount = '-amount';
            save = '-save';
            shipping = 'data-subscribe-shipping';
            sale = '';
        } else {
            subscribe = '';
            amount = '-amount';
            save = '-save';
            shipping = 'data-shipping';

            if ($('body').hasClass('show-promoBanner')) {
                sale = '-sale';
            } else {
                sale = '';
            }
        }

        // console.log('subscribe ' + subscribe);
        // console.log('sale ' + sale); 
        
        $('.cart__product').removeClass('active');
        thisProduct.addClass('active');

        $('.cart__current-value').html(thisProduct.attr('data' + sale + subscribe + amount));
        $('.cart__internet-value').html('$' + thisProduct.attr('data' + subscribe + amount));
        $('.cart__price-value').html('$' + price);
        $('.cart__save-value').html('$' + thisProduct.attr('data' + sale + subscribe + save));
        $('.cart__shipping-value').html(thisProduct.attr(shipping));
    };

    /**
     * Product Buttons Events
     */
    $('.cart__product').on('click', activeProduct);
    $('.cart__product').on('click', setLinks);
    $('.cart__product.active').trigger("click"); 

    /**
     * Ticker 
     */
    let counter;

    // recentlyBought();
    function recentlyBought() {
        const ticker = $('#ticker');
        const purchaseBox = $('#purchaseBox');
        counter = 0;

        // storage returned strings from getPurchases(), passing provided purchases array
        let purchasesArray = getPurchases(purchases);
        
        // console.log(purchasesArray.length); //- 300
        
        function appendRecentlyBought(item) {
            purchaseBox.text(item); //- change text of purchaseBox with delay of 9s
        }
        
        function animateTicker() {
            appendRecentlyBought(purchasesArray[counter]);

            // console.log('For item = ' + counter + ': ' + purchasesArray[counter]);

            ticker.addClass('anim-in').delay(2500).queue(function () {
                $(this).removeClass('anim-in').dequeue();

                counter++;

                // Reset counter when reach the end
                if (counter >= purchasesArray.length) {
                    counter = 0;
                }

                let delayTime = (Math.floor((Math.random() * ((12 - 5) + 1) + 5)) * 1000);

                // console.log('delayTime = ' + delayTime);

                setTimeout(function () {
                    animateTicker();
                }, delayTime);
            })
        }

        animateTicker();
    }

    setTimeout(function () {
        recentlyBought()
    }, 4000);

    //- Set current Year to footer Copyright
    let thisDate = new Date();
    $('#year').html(thisDate.getFullYear());
});
